<template>
    <div class="animated fadeIn">
        <b-card no-body header-tag="header">
            <div slot="header">
                <i class="fa fa-money"></i> Pagamentos
                <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </b-link>
            </div>
            <b-card-body>
                <partner-filter v-show="$auth.isPartner" @onPartnerFilterSelected="onPartnerFilterSelected"></partner-filter>                
                <hr />
                <template class="mt-5" v-if="showForm">            
                    <balance-summary v-model="balance" />
                    <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                    <form @submit.prevent="validate" class="needs-validation" novalidate>
                        <div class="form-row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label>Valor</label>
                                    <vue-numeric
                                        :separator="vueNumericDefaults.separator"
                                        :precision="vueNumericDefaults.decimals"
                                        :output-type="vueNumericDefaults.outputType"                                    
                                        v-model="model.amount"
                                        v-validate="modelValidations.amount" data-vv-name="value" data-vv-as="valor" :class="{'form-control': true, 'is-invalid': errors.has('value') ? true : false}"
                                    />
                                    <div v-show="errors.has('value')" class="invalid-feedback">
                                        {{ errors.first('value') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                        <label>Data agendamento</label>
                                        <datepicker :language="languages.ptBR" :bootstrapStyling="true" placeholder="Data" :calendar-button="true" calendar-button-icon="fa fa-calendar" v-model="model.scheduledDate" :disabled-dates="disabledDates"></datepicker>
                                    </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label for="exampleFormControlSelect1">Tipo</label>
                                    <select ref="paymentType" :class="{'form-control': true, 'is-invalid': errors.has('type')}" v-validate="modelValidations.type" v-model="model.type" data-vv-name="type" data-vv-as="tipo">
                                        <option v-for="(s, index) in paymentTypeList" :key="index" :value="s.value">
                                            {{s.text}}
                                        </option>
                                    </select>
                                    <div v-show="errors.has('type')" class="invalid-feedback">
                                        {{ errors.first('type') }}
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div class="form-row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label>Observação</label>
                                    <textarea class="form-control" v-model="model.description" id="textarea-input" name="textarea-input" rows="9" placeholder=""></textarea>
                                </div>
                            </div>
                        </div>               
                        <h4 class="mt-5">{{paymentMethodType}}</h4>
                        <hr class="mb-5" />
                        <div v-show="model.type == 'WITHDRAW'">
                            <bank-account v-model="bankAccountInfo" :action="action"  :disabled="true"/>
                        </div>
                        <div v-show="model.type == 'BANKTRANSFER'">
                            <div class="form-row justify-content-start">
                                <div class="col-sm-4">
                                    <base-input v-validate.immediate="'required_if:paymentType,WITHDRAW,BANKTRANSFER'" :disabled="isOwnerFieldsDisabled" required label="CPF / CNPJ" type="tel" placeholder="" v-model="bankAccount.document" v-validate="modelValidations.bankAccount.document" data-vv-name="bankAccount.document" data-vv-as="cpf/cnpj" :mask="['###.###.###-##', '##.###.###/####-##']" :error="getError('bankAccount.document')" />
                                </div>  
                                <div class="col-sm-6">
                                    <base-input v-validate.immediate="'required_if:paymentType,WITHDRAW,BANKTRANSFER'" :disabled="isOwnerFieldsDisabled" type="text" label="Titular" required placeholder="" v-model="bankAccount.owner" v-validate="modelValidations.bankAccount.owner" data-vv-name="bankAccount.owner" data-vv-as="titular" maxlength="255" :error="getError('bankAccount.owner')" />
                                </div>                                                              
                            </div>
                            <div class="form-row justify-content-start">
                                <div class="col-sm-3 col-md-6">
                                    <div class="form-group">
                                        <label for="name">E-mail PagBank</label>
                                        <input :disabled="isOwnerFieldsDisabled" type="email" placeholder="Digite seu e-mail" v-model="bankAccount.pagBankEmail" v-validate="modelValidations.bankAccount.pagBankEmail" :class="{'form-control': true, 'is-invalid': errors.has('bankAccount.pagBankEmail')}" data-vv-name="bankAccount.pagBankEmail" data-vv-as="e-mail PagBank" maxlength="255" />
                                        <div v-show="errors.has('bankAccount.pagBankEmail')" class="invalid-feedback">
                                            {{ errors.first('bankAccount.pagBankEmail') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row justify-content-start">
                                <div class="col-sm-3 col-md-4">
                                    <div class="form-group">
                                        <label for="exampleFormControlSelect1">Banco</label>
                                        <select v-validate.immediate="'required_if:paymentType,WITHDRAW,BANKTRANSFER'" :disabled="isOwnerFieldsDisabled" :class="{'form-control': true, 'is-invalid': errors.has('bankAccount.bankCode')}" v-validate="modelValidations.bankAccount.bankCode" v-model="bankAccount.bankCode" data-vv-name="bankAccount.bankCode" data-vv-as="banco">
                                            <option v-for="(s, index) in bankList" :key="index" :value="s.COMPE" v-text="s.COMPE == null ? s.LongName : `${s.COMPE} - ${s.LongName}`"></option>
                                        </select>
                                        <div v-show="errors.has('bankAccount.bankCode')" class="invalid-feedback">
                                            {{ errors.first('bankAccount.bankCode') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row justify-content-start">
                                <div class="col-sm-2">
                                    <base-input v-validate.immediate="'required_if:paymentType,WITHDRAW,BANKTRANSFER'" :disabled="isOwnerFieldsDisabled" required label="Agencia (sem digito)" type="tel" placeholder="" v-model="bankAccount.branchNumber" v-validate="modelValidations.bankAccount.branchNumber" data-vv-name="bankAccount.branchNumber" data-vv-as="agência" maxlength="4" :error="getError('bankAccount.branchNumber')" />
                                </div>
                                <div class="col-sm-2">
                                    <div class="form-group">
                                        <label for="name">Conta</label>                                    
                                        <the-mask v-validate.immediate="'required_if:paymentType,WITHDRAW,BANKTRANSFER'" :disabled="isOwnerFieldsDisabled" required type="tel" placeholder="" v-model="bankAccount.number" v-validate="modelValidations.bankAccount.number" data-vv-name="bankAccount.number" data-vv-as="conta-corrente" maxlength="14" :class="{'form-control': true, 'is-invalid': errors.has('bankAccount.number')}" :mask="['#####-#', '######-#', '#######-#', '########-#', '#########-#', '##########-#', '###########-#', '############-#']" />
                                        <div v-show="errors.has('bankAccount.number')" class="invalid-feedback">
                                            {{ errors.first('bankAccount.number') }}
                                        </div>
                                    </div>                
                                </div>
                                <div class="col-sm-2">
                                    <div class="form-group">
                                        <label for="exampleFormControlSelect1">Tipo</label>
                                        <select v-validate.immediate="'required_if:paymentType,WITHDRAW,BANKTRANSFER'" :disabled="isOwnerFieldsDisabled" :class="{'form-control': true, 'is-invalid': errors.has('bankAccount.type')}" v-validate="modelValidations.bankAccount.type" v-model="bankAccount.type" data-vv-name="bankAccount.type" data-vv-as="tipo">
                                            <option v-for="(s, index) in bankAccountTypeList" :key="index" :value="s.value">
                                                {{s.text}}
                                            </option>
                                        </select>
                                        <div v-show="errors.has('bankAccount.type')" class="invalid-feedback">
                                            {{ errors.first('bankAccount.type') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="model.type == 'BILLPAYMENT'">
                            <div class="form-row">
                                <div class="col-sm-4">
                                    <base-input v-validate.immediate="'required_if:paymentType,BILLPAYMENT'" type="text" label="Favorecido" required placeholder="" v-model="billPayment.recipientName" data-vv-name="billPayment.recipientName" data-vv-as="favorecido" maxlength="255" :error="getError('billPayment.recipientName')" />
                                </div>
                                <div class="col-sm-4">
                                    <base-input v-validate.immediate="'required_if:paymentType,BILLPAYMENT'" required label="Cnpj / Cpf Emissor" type="tel" placeholder="" v-model="billPayment.recipientDocument" data-vv-name="billPayment.recipientDocument" data-vv-as="cpf/cnpj" :mask="['###.###.###-##', '##.###.###/####-##']" :error="getError('billPayment.recipientDocument')" />
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="exampleFormControlSelect1">Tipo Boleto</label>
                                        <select v-validate.immediate="'required_if:paymentType,BILLPAYMENT'" :class="{'form-control': true, 'is-invalid': errors.has('type')}" v-model="billPayment.documentType" data-vv-name="billPayment.documentType" data-vv-as="tipo">
                                            <option v-for="(s, index) in billPaymentTypeList" :key="index" :value="s.value">
                                                {{s.text}}
                                            </option>
                                        </select>
                                        <div v-show="errors.has('billPayment.documentType')" class="invalid-feedback">
                                            {{ errors.first('billPayment.documentType') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-sm-8">
                                    <base-input v-validate.immediate="'required_if:paymentType,BILLPAYMENT'" type="text" label="Código boleto" required placeholder="" v-model="billPayment.barCode" data-vv-name="billPayment.barCode" data-vv-as="Codigo boleto" maxlength="255" :error="getError('billPayment.barCode')" />
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Vencimento</label>
                                        <datepicker :language="languages.ptBR" :bootstrapStyling="true" placeholder="Vencimento" :calendar-button="true" calendar-button-icon="fa fa-calendar" v-model="billPayment.dueDateAt"></datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>             
                        <div v-show="model.type == 'PIXTRANSFER'">
                            <div class="form-row">
                                <div class="col-sm-4">
                                    <base-input v-validate.immediate="'required_if:paymentType,PIXTRANSFER'" type="text" label="Favorecido" required placeholder="" v-model="pixTransfer.recipientName" data-vv-name="pixTransfer.recipientName" data-vv-as="favorecido" maxlength="255" :error="getError('pixTransfer.recipientName')" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="exampleFormControlSelect1">Tipo de chave</label>
                                        <select v-validate.immediate="'required_if:paymentType,PIXTRANSFER'" :class="{'form-control': true, 'is-invalid': errors.has('keyType')}" v-model="pixTransfer.keyType" data-vv-name="pixTransfer.keyType" data-vv-as="tipo de chave">
                                            <option v-for="(s, index) in pixKeyTypeList" :key="index" :value="s.value">
                                                {{s.text}}
                                            </option>
                                        </select>
                                        <div v-show="errors.has('pixTransfer.keyType')" class="invalid-feedback">
                                            {{ errors.first('pixTransfer.keyType') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-8">
                                    <base-input v-validate.immediate="'required_if:paymentType,PIXTRANSFER'" type="text" label="Chave Pix" required placeholder="" v-model="pixTransfer.pixKey" data-vv-name="pixTransfer.pixKey" data-vv-as="Chave Pix" maxlength="255" :error="getError('pixTransfer.pixKey')" />
                                </div>                            
                            </div>
                        </div>
                        <hr class="mt-5" />
                        <button type="submit" class="btn btn-primary">Salvar</button>
                    </form>
                </template>
            </b-card-body>
        </b-card>                
    </div>
</template>
<script>
import helperService from '../../../services/Helper/helperService'
import domainService from '../../../services/MoneyFlow/moneyOutService'
import bankAccountService from '../../../services/Customer/bankAccountService'
import transactionService from '../../../services/Transactions/transactionService'
import editPage from '../../../mixins/editPage'
import PartnerFilter from '../../../components/PartnerFilter'
import Datepicker from 'vuejs-datepicker'
import * as lang from "vuejs-datepicker/src/locale"
import _ from 'lodash'
import BankAccount from '../../../components/customers/bankAccount.vue'
import BalanceSummary from "../../../components/balance/summary2.vue"
import eventbus from "../../../eventBus"
export default {
    props: {
        id: String
    },
    components: {
        Datepicker,
        PartnerFilter,
        BankAccount,
        BalanceSummary
    },
    mixins: [editPage],
    data() {
        return {
            languages: lang,
            actionUri: '/partners/payments',
            currentPartnerFilter: {
                role: '',
                id: '',
                name: ''
            },
            vueNumericDefaults: {
                decimals: 2,
                separator: '.',
                outputType: 'Number'
            },
            bankAccountInfo: this.getEmptyBankAccount(),
            bankAccount: this.getEmptyBankAccount(),
            billPayment: this.getEmptyBillPayment(),
            pixTransfer: this.getEmptyPixTransfer(),
            model: this.getEmptyModel(),
            modelValidations: {
                amount: {
                    required: true
                },
                scheduledDate: {
                    required: true
                },
                pixTransfer:{
                    pixKey: {
                        max:255,
                        required_if: 'paymentType,PIXTRANSFER'
                    },
                    keyType: {
                        required_if: 'paymentType,PIXTRANSFER'
                    },
                    recipientName: {
                        max:255,
                        required_if: 'paymentType,PIXTRANSFER'
                    },
                },
                billPayment: {
                    recipientName: {
                        max:255,
                        required_if: 'paymentType,BILLPAYMENT'
                    },
                    recipientDocument: {
                        max:255,
                        required_if: 'paymentType,BILLPAYMENT'
                    },
                    documentType: {
                        required_if: 'paymentType,BILLPAYMENT'
                    },
                    barCode: {
                        required_if: 'paymentType,BILLPAYMENT'
                    }
                },
                bankAccount: {
                    owner: {
                        required_if: 'paymentType,BANKTRANSFER'
                    },
                    document: {
                        required_if: 'paymentType,BANKTRANSFER'
                    },
                    number: {
                        required_if: 'paymentType,BANKTRANSFER',
                        min: 6,
                        max: 13
                    },
                    branchNumber: {
                        required_if: 'paymentType,BANKTRANSFER',
                        max: 10
                    },
                    documentType: {
                        required_if: 'paymentType,BANKTRANSFER',
                    },
                    bankCode: {
                        required_if: 'paymentType,BANKTRANSFER',
                    },
                    pagBankEmail: {
                        required: false,
                        email: true
                    },
                    type: {
                        required_if: 'paymentType,BANKTRANSFER'
                    }
                }                                  
            },
            bankList:[],
            bankAccountTypeList:[
                {
                    value: null,
                    text: 'Selecione'
                },
                {
                    value: 'CHECKING',
                    text: 'Conta-corrente'
                },
                {
                    value: 'SAVINGS',
                    text: 'Poupança'
                }
            ],
            paymentTypeList:[                
                {
                    value: 'WITHDRAW',
                    text: 'Saque'
                },
                {
                    value: 'BILLPAYMENT',
                    text: 'Boleto'
                },
                {
                    value: 'BANKTRANSFER',
                    text: 'Transferência'
                },
                {
                    value: 'PIXTRANSFER',
                    text: 'Transferência Pix'
                }
            ],
            billPaymentTypeList: [
                {
                    value: '1',
                    text: 'Bancário'
                },
                {
                    value: '2',
                    text: 'Água / Luz'
                },
                {
                    value: '3',
                    text: 'Outro'
                }
            ], 
            pixKeyTypeList: [
                {
                    value: 'DOCUMENTNUMBER',
                    text: 'CPF / CNPJ'
                },
                {
                    value: 'PHONE',
                    text: 'Telefone'
                },
                {
                    value: 'RANDOM',
                    text: 'Aleatória'
                }
            ],     
            balance: this.getEmptyBalanceSummary(),
            disabledDates: {
                to: new Date(new Date().setDate(new Date().getDate() - 1))
            }
        }
    },
    computed: {
        action() {
            return this.$route.name
        },
        paymentMethodType() {
            switch (this.model.type)
            {
                case 'BANKTRANSFER':
                    return 'Transferência';
                case 'BILLPAYMENT':
                    return 'Boleto';
                case 'WITHDRAW':
                    return 'Saque';
                    case 'PIXTRANSFER':
                    return 'Pix';
            }
        },
        showForm() {
            if(!this.$auth.isPartner) {
                return true
            }

            return this.currentPartnerFilter.role != ''
        },
        isOwnerFieldsDisabled() {
            if(this.model.type == 'WITHDRAW') {
                return true
            }
            return false
        }
    },
    watch: {
        'bankAccount.document': function(newValue) {
            if(newValue != null) {
                this.bankAccount.documentType = newValue.length <= 11 ? 'F' : 'J'
            }                        
        },
        'model.type': function(newValue) {
            this.bankAccount = this.getEmptyBankAccount();
            if(newValue == 'WITHDRAW') {
                this.bankAccount = _.clone(this.bankAccountInfo);
            }                      
        }
    },
    created() {
        if(!this.$auth.isPartner) {
            this.fetchData();           
        }
    },    
    methods: {
        clearResult() {
        return this.getEmptyBalanceSummary();
        },
        getEmptyBalanceSummary() {
        return { available: 0, inProcess: 0, blocked: 0, total: 0, openDebits: 0 }
        },
        getEmptyModel() {
            return {
                amount: 0,
                scheduledDate: new Date(),
                type: 'WITHDRAW',
                description: ''                
            }            
        },
        getEmptyBankAccount() {
            return {
                owner: '',
                document: '',
                number: '',
                branchNumber: '',
                documentType: '',
                bankCode: null,
                type: null,
                pagBankEmail: '',
                customerId: '',
                status: 'ACTIVE'
            }
        },
        getEmptyBillPayment() {
            return {
                dueDateAt: new Date(),
                recipientName: '',
                recipientDocument: '',
                documentType: '1',
                barCode: ''
            }
        },
        getEmptyPixTransfer() {
            return {
                pixKey: '',
                keyType: 'DOCUMENTNUMBER',
                recipientName: ''
            }
        },
        clearForm() {
            this.model = this.getEmptyModel()
            this.bankAccount = this.getEmptyBankAccount()
            this.billPayment = this.getEmptyBillPayment()
            this.pixTransfer = this.getEmptyPixTransfer()
        },
        onPartnerFilterSelected(filter) {
            this.currentPartnerFilter = filter
            this.clearForm()
            this.fetchData()            
        },        
        fetchSummaryData(customerId, customerType) {
            const self = this
            
            transactionService.balance({customerId: customerId, customerType: customerType})
                .then(
                (response) => {
                        if (response.status == 204) {
                            self.balance.available = 0;
                            self.balance.inProcess = 0;
                            self.balance.total = 0;
                            self.balance.blocked = 0;
                            self.balance.openDebits = 0;       
                        }
                        else {
                            self.balance.available = response.data.available;
                            self.balance.inProcess = response.data.inProcess;
                            self.balance.total = response.data.total;              
                            self.balance.blocked = response.data.onHold;
                            self.balance.openDebits = response.data.openDebits;       
                        }                        
                    },
                    () => {}
                );
        },
        fetchData() {
            const self = this;
            let id = '';
            let customerType = '';
            if(this.$auth.isPartner) {
                id = this.currentPartnerFilter.id
                customerType = this.currentPartnerFilter.role;
            }
            else {
                id = this.$auth.customerId
                customerType = this.$auth.userRole
            }

            this.fetchSummaryData(id, customerType)
            
            helperService.banksGetList().then((response) =>{
                self.bankList = response.status == 204 ? [] : response.data
                self.bankList.unshift({ COMPE: null, LongName: 'Selecione um banco'})
                //self.hideLoading()
            }, () => {
                //self.hideLoading()
            })

            
            self.showLoading()
            bankAccountService.find(id).then((response) => {
                self.bankAccountInfo = response.data
                self.bankAccount = response.data
                self.hideLoading()
            }, () => {
                self.hideLoading()
            })            
        },
        validate() {
            const self = this
            self.showLoading()
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    let entity = { 
                        amount: self.model.amount,
                        type: self.model.type,
                        description: self.model.description,
                        scheduledDate: self.model.scheduledDate,                        
                        isAdvanceOnReceivables: false,
                        moneyOutGroupId: null,
                        customerId: self.$auth.isPartner ? self.currentPartnerFilter.id : null,
                        customerType: self.$auth.isPartner ? self.currentPartnerFilter.role : null,
                        customerName: self.$auth.isPartner ? self.currentPartnerFilter.name : null,
                        customerDocument: self.$auth.isPartner ? self.currentPartnerFilter.documentNumber : null
                    }
                    if(self.model.type == 'WITHDRAW') {
                        domainService.createWithDraw(entity).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:self.actionUri })
                        },
                        error => {
                            self.hideLoading()
                            self.showError(error.response.data.message)
                        })
                    }

                    if(self.model.type == 'PIXTRANSFER') {
                        entity.pixKey = self.pixTransfer.pixKey;
                        entity.keyType = self.pixTransfer.keyType;
                        entity.recipientName = self.pixTransfer.recipientName;
                        domainService.createPixTransfer(entity).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:self.actionUri })
                        },
                        error => {
                            self.hideLoading()
                            self.showError(error.response.data.message)
                        })
                    }

                    if(self.model.type == 'BANKTRANSFER') {
                        entity.owner = self.bankAccount.owner;
                        entity.document = self.bankAccount.document;
                        entity.number = self.bankAccount.number;
                        entity.branchNumber = self.bankAccount.branchNumber;
                        entity.documentType = self.bankAccount.documentType;
                        entity.bankCode = self.bankAccount.bankCode;
                        entity.accountType = self.bankAccount.type;
                        entity.pagBankEmail = self.bankAccount.pagBankEmail;
                        domainService.createBankTransfer(entity).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:self.actionUri })
                        },
                        error => {
                            self.hideLoading()
                            self.showError(error.response.data.message)
                        })
                    }

                    if(self.model.type == 'BILLPAYMENT') {
                        entity.dueDateAt = self.billPayment.dueDateAt
                        entity.recipientName = self.billPayment.recipientName
                        entity.recipientDocument = self.billPayment.recipientDocument
                        entity.documentType = self.billPayment.documentType
                        entity.barCode = self.billPayment.barCode
                        domainService.createBillPayment(entity).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:self.actionUri })
                        },
                        error => {
                            self.hideLoading()
                            self.showError(error.response.data.message)
                        })
                    }
                } 
                else 
                {
                    self.hideLoading()
                }
            })
        }        
    }
}
</script>